<section class="subgrupo-shell">
  <header class="subgrupo-hero">
    <div>
      <h2 class="subgrupo-title">{{ isEditMode ? 'Editar Subgrupo de Despesas' : 'Novo Subgrupo de Despesas' }}</h2>
      <p class="subgrupo-subtitle">Vincule o subgrupo ao seu grupo de despesa correspondente.</p>
    </div>
    <span class="subgrupo-chip">{{ isEditMode ? 'Edição' : 'Cadastro' }}</span>
  </header>

  <form (ngSubmit)="save()" id="subgrupoForm" class="subgrupo-card">
    <div class="form-section">
      <h3>Identificação</h3>
      <div class="row g-3">
        <div class="col-md-6">
          <label for="grupo" class="form-label">Grupo</label>
          <select id="grupo" [(ngModel)]="subgrupo.grupo.id" name="grupo" class="form-control" required>
            <option *ngFor="let grupo of grupos" [value]="grupo.id">{{ grupo.nome }}</option>
          </select>
        </div>
        <div class="col-md-6">
          <label for="nome" class="form-label">Nome</label>
          <input type="text" id="nome" [(ngModel)]="subgrupo.nome" name="nome" class="form-control" required>
        </div>
      </div>
    </div>
  </form>

  <footer class="action-bar">
    <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancelar</button>
    <button type="submit" form="subgrupoForm" class="btn btn-primary">Salvar</button>
  </footer>
</section>
